import React, { useRef, useEffect } from 'react';
import FileUploader from '../FileUploader';
import FileManager from '../FileManager';

export default function WindowFileManager({ onClose }) {
  const fileManagerRef = useRef();
  // Обробник клавіші Escape для закриття вікна
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  const handleFileUploadSuccess = () => {
    // Оновлюємо файловий менеджер після успішного завантаження
    if (fileManagerRef.current) {
      fileManagerRef.current.refresh();
    }
  };
  return (
    <div style={{
      position: 'fixed',
      top: '8px',
      left: '8px',
      right: '8px',
      bottom: '8px',
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      zIndex: 1000,
      border: '1px solid #ccc',
      borderRadius: '12px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.15)'
    }}>      {/* Шапка с крестиком */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 12px',
        backgroundColor: '#1976d2',
        color: 'white',
        borderBottom: '1px solid #e0e0e0',
        borderRadius: '12px 12px 0 0'      }}>
        <h2 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Управління файлами</h2>
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            color: 'white',
            padding: '8px',
            borderRadius: '6px',
            minHeight: '40px',
            minWidth: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          title="Закрити"
        >
          ✕
        </button>
      </div>      {/* Робоча область */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        padding: '12px',
        overflow: 'hidden'
      }}>

        {/* Секція завантаження файлів */}
        <div style={{
          maxHeight: '40%',
          overflow: 'auto',
          border: '2px solid #e0e0e0',
          borderRadius: '8px',
          padding: '10px',
          backgroundColor: '#f8f9fa'
        }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '12px',
              padding: '12px',
              background: 'linear-gradient(135deg, #e3f2fd 0%, #2196f3 100%)',
              border: '1px solid #2196f3',
              borderRadius: '8px',
              boxShadow: '0 2px 6px rgba(33, 150, 243, 0.2)',
              flexShrink: 0
            }}
          >
            <span style={{ fontSize: '32px', marginRight: '12px' }}>📁</span>
            <div>              <h3
                style={{
                  margin: 0,
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#0d47a1'
                }}
              >
                Завантаження файлів
              </h3>
              <div style={{
                fontSize: '14px',
                color: '#1565c0',
                fontWeight: '500',
                marginTop: '2px'
              }}>
                Додавання нових файлів • Імпорт даних
              </div>
            </div>
          </div>
          <FileUploader onSuccess={handleFileUploadSuccess} />
        </div>        {/* Секція менеджера файлів */}
        <div style={{
          flex: 1,
          overflow: 'hidden',
          border: '2px solid #e0e0e0',
          borderRadius: '8px',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          flexDirection: 'column'
        }}>
            <FileManager ref={fileManagerRef} />
        </div>
      </div>
    </div>
  );
}
